/**********************************************************************************
CHID       WHO         WHEN            WHY
********************************************************************************
CHID-1      Usha       24/01/2020      1973: Related Symptoms Implementation
*********************************************************************************/
import { commonConstant } from "../../../server/triage/constants";
import { generateJsonWebToken, checkAndGetLocalStorageValue, checkAndGetSessionStorageValue } from "../../../features/utils";

export async function getRelatedSymptoms({ state, actions, setState, nextStepName, history, RelatedSymptomCallback, lang }) {
    const data = getDataForGetRelatedSymptom(state, lang, actions)
    window.store = store
    const country = state.triageRequest.location.parts.country
    localStorage.setItem("countryname", country)
    const province = state.triageRequest.location.parts.administrative_area_level_2
    const state1 = state.triageRequest.location.parts.administrative_area_level_1
    const city = state.triageRequest.location.parts.locality
    localStorage.setItem("cityname", city)
    localStorage.setItem("statename", state1)
    localStorage.setItem("provincename", province)

    var response = await actions.sendTriageRequest({
        action: "GetRelatedSymptom",
        data
    });

    if (response && response.message === commonConstant.success) {
        var symptomsInfo = response.symptomsInfo
        setState({
            RelatedSymptomInfo: symptomsInfo
        })
        await RelatedSymptomCallback(state, nextStepName, history, actions, setState);
    }
}

export function getDataForGetRelatedSymptom(state, lang, actions) {
    const { triageRequest } = state
    let { sessionId, ageInYears, gender } = triageRequest
    const encounterToken = localStorage.getItem('token')
    var jwtAccess_Token = generateJsonWebToken()
    var access_Token = checkAndGetSessionStorageValue("accessToken")
    const symptomSearchResult = []
    let data = {}
    let genderFemale = 'female'
    let genderMale = 'male'
    if (gender === 'F')
        gender = genderFemale
    if (gender === 'M')
        gender = genderMale
    if (triageRequest.pregnant === true) {
        data = { Id: 'p_42', ChoiceId: '', Initial: false }
        symptomSearchResult.push(data)
    }
    if (triageRequest.selectChildBirth === "Yes") {
        data = { Id: 'p_55', ChoiceId: '', Initial: false }
        symptomSearchResult.push(data)
    }
    for (var i = 0; i < state.currentSymptomsSortedKeys.length; i++) {
        var s1 = state.currentSymptomsSortedKeys[i]
        data = { Id: s1, ChoiceId: '', Initial: true }
        symptomSearchResult.push(data)
    }
    const reqData = {
        LanguageId: actions.getLanguage(lang),
        Age: ageInYears,
        Gender: gender,
        PresentEvidence: symptomSearchResult,
        AbsentEvidence: [],
        Identifier: sessionId,
        Token: encounterToken,
        jwtAccessToken: jwtAccess_Token,
        accessToken: access_Token
    }
    return reqData;
}

export async function submitEmergencyAnswers({ state, actions, setState }) {
    let PresentRelated = {}
    let AbsentRelated = {}
    let emergencyAnswers = []
    const { triageRequest } = state
    const { presentRelatedSymptomsMap } = triageRequest
    const { absentRelatedSymptomsMap } = triageRequest

    for (const key of Object.keys(presentRelatedSymptomsMap)) {
        var id = presentRelatedSymptomsMap[key].emergencyQuestionId;
        let n = id;
        if (id == n) {
            PresentRelated = { emergenctQuestionId: n, Answer: "yes" }
            emergencyAnswers.push(PresentRelated)
        }
    }
    for (const key of Object.keys(absentRelatedSymptomsMap)) {
        var id = absentRelatedSymptomsMap[key].emergencyQuestionId;
        let n = id;
        if (id == n) {
            AbsentRelated = { emergenctQuestionId: n, Answer: "no" }
            emergencyAnswers.push(AbsentRelated)
        }
    }
    const { sessionId } = triageRequest
    const encounterToken = localStorage.getItem('token')
    var jwtAccess_Token = generateJsonWebToken()
    var access_Token = checkAndGetSessionStorageValue("accessToken")
    const answerId = ""
    const data = {
        identifier: sessionId,
        Token: encounterToken,
        EmergencyAnswersList: emergencyAnswers,
        jwtAccessToken: jwtAccess_Token,
        accessToken: access_Token,
    };
    var isEmrgencyAnswerAdded = localStorage.getItem("isEmrgencyAnswerAdded");
    if (isEmrgencyAnswerAdded == "true")
        await actions.sendTriageRequest({ action: 'updateEmergencyAnswers', data })
    else
        await actions.sendTriageRequest({ action: 'submitEmergencyAnswers', data })
    localStorage.setItem("isEmrgencyAnswerAdded", true);
    setState({isEmrgencyAnswerAdded: true});
}

export async function submitRelatedSymptoms({ state, actions, setState }) {
    const PresentRelated = []
    const AbsentRelated = []
    const { triageRequest } = state
    const { presentRelatedSymptomsMap } = triageRequest
    const { absentRelatedSymptomsMap } = triageRequest
    for (const key of Object.keys(presentRelatedSymptomsMap)) {
        const { id } = presentRelatedSymptomsMap[key]
        PresentRelated.push(id)
    }
    for (const key of Object.keys(absentRelatedSymptomsMap)) {
        const { id } = absentRelatedSymptomsMap[key]
        AbsentRelated.push(id)
    }
    const { sessionId } = triageRequest
    const encounterToken = localStorage.getItem('token')
    var jwtAccess_Token = generateJsonWebToken()
    var access_Token = checkAndGetSessionStorageValue("accessToken")
    const data = {
        identifier: sessionId,
        Token: encounterToken,
        PresentRelated,
        AbsentRelated,
        jwtAccessToken: jwtAccess_Token,
        accessToken: access_Token,
    }
    await actions.sendTriageRequest({ action: 'submitRelatedSymptoms', data })
}
export async function FindMember({ state, actions, setState }) {
    const { triageRequest } = state
    const { sessionId, policyNumber } = triageRequest;
    const encounterToken = localStorage.getItem('token');
    var jwtAccess_Token = generateJsonWebToken();
    var access_Token = checkAndGetSessionStorageValue("accessToken");
    var organizationId = checkAndGetLocalStorageValue("orgid");
    var dob = state.triageRequest.dateofbirth;
    var tempName = state.triageRequest.data.username;
    
    const data = {
        identifier: sessionId,
        Token: encounterToken,
        jwtAccessToken: jwtAccess_Token,
        accessToken: access_Token,
        fullName : tempName,
        PolicyNumber : state.triageRequest.data.policyNum,
        dOB : dob,
        organizationCode : organizationId
    };
    var response =  await actions.sendTriageRequest({ action: 'FindMember', data })
    return response;
}
export async function AddOrUpdateMemberSearch({ state, actions, setState, result }) {
    const { triageRequest } = state
    const { sessionId, policyNumber } = triageRequest;
    const isSearchMemberAdded = localStorage.getItem('isSearchMemberAdded');
    const encounterToken = localStorage.getItem('token');
    var jwtAccess_Token = generateJsonWebToken();
    var access_Token = checkAndGetSessionStorageValue("accessToken");
    var organizationId = checkAndGetLocalStorageValue("orgid");
    var dob = state.triageRequest.dateofbirth;
    var tempName = state.triageRequest.data.username;
    
    const data = {
        identifier: sessionId,
        Token: encounterToken,
        jwtAccessToken: jwtAccess_Token,
        accessToken: access_Token,
        searchResult : result
    };
    if(!isSearchMemberAdded)
        var response =  await actions.sendTriageRequest({ action: 'AddMemberSearch', data })
    else
        var response =  await actions.sendTriageRequest({ action: 'UpdateMemberSearch', data })
    return response;
}